@if (alertInfo.show) {
  <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
    {{ alertInfo.message }}
  </ngb-alert>
}
<form [formGroup]="form">
  <div class="row g-3">
    <div class="col-sm-12 col-md-6 mt-2">
      <autocomplete-field [label]="'Client'" [placeholder]="'Search...'"
        [inputFormControl]="getProposalClientInput()" [readonly]="isClientReadonly()"
        [displayKeyValue]="true" (valueChange)="onClientSearchValueChange($event)"
        [apiService]="customerService" [apiMethod]="'list'" [minChars]="1" [useApiSearch]="true"
        [nameApiSearch]="'companyName'" [optionsKey]="'customers'" [valueOption]="'companyName'"
        [keyOption]="'customerId'" />
    </div>

    <div class="col-sm-12 col-md-6 mt-2 brand-name-container">
      <input-field type="text" [readonly]="readonlyProposalsForm" [inputFormControl]="getProposalBrandNameInput()" label="Brand Name" placeholder="Brand Name" />
    </div>

  </div>
  <div class="row g-3 mt-1">
    <div class="col-sm-6 col-md-auto mt-2 client-code-container">
      <input-field type="text" [readonly]="readonlyProposalsForm" [inputFormControl]="getProposalCompanyCodeInput()" label="Client Code" placeholder="Client Code" />
    </div>
    <div class="col-sm-5 col-md-auto mt-2">
      <div class="form-group text-start">
        <label class="fw-bold">Related Requests</label>
        <div class="input-group justify-content-center">
          <button type="button" class="btn btn-outline-primary fs-8 w-100" [routerLink]="'/app/requests/' + this.proposal?.request.requestId">
            <span>{{proposal?.request.code || 'N/A'}}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="col-sm-1 col-md-auto mt-2 d-flex align-items-center justify-content-center ms-auto">
      <language-client [radioFormControl]="getProposalLanguageInput()" [compactView]="true" />
    </div>
  </div>
</form>